import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { logout } from "../actions/auth"
import {
	getPlickDetail,
	PlickDetailState,
	PlickResponse,
} from "../actions/plick-detail"

const initialState: PlickDetailState = {
	loading: false,
	error: undefined,
	data: undefined,
}

const plickDetailSlice = createSlice({
	name: "plickDetail",
	initialState: initialState,
	reducers: {
		clearError: (state: PlickDetailState) => {
			state.error = undefined
			state.loading = false
		},
		clearDefault: (state: PlickDetailState) => {
			state = initialState
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(logout.fulfilled, () => initialState)
			.addCase(getPlickDetail.pending, (state: PlickDetailState) => {
				state.loading = true
				state.error = undefined
				state.data = undefined
			})
			.addCase(
				getPlickDetail.fulfilled,
				(state: PlickDetailState, action: PayloadAction<PlickResponse>) => {
					state.loading = false
					state.error = undefined
					state.data = action?.payload
				}
			)
			.addCase(getPlickDetail.rejected, (state: PlickDetailState, action) => {
				state.loading = true
				state.error =
					typeof action?.payload === "string" || action?.payload?.message
						? {
								message:
									(action?.payload?.message || action?.payload) ?? "generic",
							}
						: {
								message: "generic",
							}
				state.data = undefined
			})
	},
})

export const { clearError, clearDefault } = plickDetailSlice.actions

export default plickDetailSlice.reducer
